import { Box, CircularProgress } from '@mui/material';

export interface LoaderProps {
  /** SR-announced label. Defaults to "Loading". */
  label?: string;
}

/**
 * Centered spinner with a polite live region.
 *
 * Use anywhere the page-level data is fetching. SR users hear the label when the
 * region is first inserted into the DOM.
 *
 * WCAG 4.1.3 Status Messages (Level AA).
 */
export default function Loader({ label = 'Loading' }: LoaderProps) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200
      }}
    >
      <CircularProgress aria-label={label} />
    </Box>
  );
}
